module.exports = __webpack_public_path__ + "img/pssccreen1.d56a6786.png";